import './index.css';
import logo_hogcloud1 from "../../assets/images/hogcloud-logo1.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faHome, faShoppingCart } from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
   return ( <>
    <div className="footer">
    <div className="footer-left">
        <a href="/"><img src={logo_hogcloud1} alt="hogcloud logo pig in cloud" 
          className="hc_logo_small responsive-logo"/> </a>&copy; 2021 - {new Date().getFullYear()} Hogcloud, Inc.
    </div>
    <div className="footer-right">
      <a href="/cart" className="cart-icon">
      <FontAwesomeIcon icon={faShoppingCart} className='hc-nav-icon-spacing' />
  
      </a> 
      <a href="/" className="home-icon">
        <FontAwesomeIcon icon={faHome} className='hc-nav-icon-spacing' />
      </a>
      <a href="mailto:sales@hogcloud.net" className="email-icon">
       <FontAwesomeIcon icon={faEnvelope} className='hc-nav-icon-spacing' />
      </a>
    </div>
    </div>
  </>);
}

export default Footer;